import { render } from "./quantity.vue?vue&type=template&id=5fc68dfb"
const script = {}

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__